import { AthosFetcher } from '../classes/athos-fetcher'
import { normaliseResults } from '../helpers/normalisers'
import { generateAthosProvider } from './provider'

export class AthosProduct extends AthosFetcher {
  generateURL() {
    return super.generateURL('/search')
  }

  updateParams(options = {}) {
    const { handle } = options

    this.params.setDomainParam()
    this.params.set('resultsFormat', 'native')
    this.params.set('redirectResponse', 'full')
    this.params.set('resultsPerPage', 1)
    this.params.set('bgfilter.handle', handle)

    super.updateParams()
  }
}

export const AthosProductProvider = generateAthosProvider(AthosProduct, (results) => {
  return {
    ...results,
    results: normaliseResults(results?.results)
  }
})
